<template>
    <nav class="navbar navbar1 navbar-custom navbar-transparent navbar-fixed-top one-page"  role="navigation" id="navbar">
        <div class="">
          <div class="navbar-header">
            <button class="navbar-toggle" type="button" data-toggle="collapse" data-target="#custom-collapse" v-on:click="openNav">
              <span class="sr-only">Toggle navigation</span><span class="icon-bar"></span>
              <span class="icon-bar"></span><span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="/">
              <img width="242" height="38"  src="/static/assets/images/dwerve-title2.png" class="img-fluid dwerve-logo" alt="dwerve">
            </a>
          </div>
          <div class="collapse navbar-collapse" id="custom-collapse" v-bind:class="{active: isActive}">
            <ul class="nav navbar-nav navbar-left" style="margin-top: 14px;">
              <li><a href="https://discordapp.com/invite/halfhumangames" target="_blank" rel="noopener noreferrer">Discord</a></li>
              <li><a href="/#media" >Media</a></li>
               <li><a href="/#press">Press</a></li>
              <li><a href="/faq">FAQ</a></li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
             <li class="suscribeList"><img class="bounce_button" src="/static/assets/images/Subscribe.png" v-on:click.prevent="openSendyModal();openNav();" alt="dwerve"></li>
            </ul>
          </div>
        </div>
      </nav>
</template>

<script>

export default {
  data() {
    return {
      navbar1: false,
      test: this.$store,
      isActive: false,
      mediaLink: ""
    };
  },
  methods: {
    getMediaLink(){
      if (this.$route.path == "/") {
        this.mediaLink = location.href + "#media";
      }
      else if (this.$route.name == "FAQ") {
        this.mediaLink = "/#media";
      }
    },
    scroll() {
      if (this.$store.state.Navbar == false) {
        window.onscroll = function() {
          navbarMove();
          socialNavMove();
          scrollUp();
        };
      }
      function navbarMove() {
        if (
          document.body.scrollTop > 20 ||
          document.documentElement.scrollTop > 20
        ) {
          document.getElementById("navbar").style.top = "0";
          document.getElementById("navbar").style.zIndex = "2";
          document.getElementById("navbar").style.opacity = "1";
          document.getElementById("socialNav").style.zIndex = "2"
        } else {
          document.getElementById("navbar").style.top = "-100px";
          document.getElementById("navbar").style.zIndex = "1";
          document.getElementById("navbar").style.opacity = "0";
          document.getElementById("socialNav").style.zIndex = "1"
        }
      }
      function socialNavMove() {
        if (
          document.body.scrollTop > 20 ||
          (document.documentElement.scrollTop > 20 &&
            document.documentElement.clientWidth > 500)
        ) {
          document.getElementById("socialNav").style.marginLeft = "-58px";
        } else {
          document.getElementById("socialNav").style.marginLeft = "0";
        }
      }
      function scrollUp() {
        if (
          document.body.scrollTop > 20 ||
          (document.documentElement.scrollTop > 20)
        ) {
          document.getElementById("scroll-up").style.display = "block";
        } else {
          document.getElementById("scroll-up").style.display = "none";
        }
      }
    },
    noMove() {
      if (this.$route.name == "FAQ" || this.$route.name == "Home2") {
        this.$store.state.Navbar = true;
        document.getElementById("navbar").style.top = "0";
        document.getElementById("navbar").style.zIndex = "1";
      }
    },
    openSendyModal() {
      document.getElementById("mySendyModal").style.display = "flex";
    },
    closeSendyodal() {
      document.getElementById("mySendyModal").style.display = "none";
       console.log('hey')
    },
    setZIndex(){
      if(document.getElementById("myFollowModal").style.display == "block") {
        document.getElementById("navbar").style.zIndex = "1";
        document.getElementById("socialNav").style.zIndex = "1"
      }
      else{
        document.getElementById("navbar").style.zIndex = "2";
        document.getElementById("socialNav").style.zIndex = "2"
      }
     
    },
    showMailingPopUp(){
      document.cookie = "MCEvilPopupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    },
    openNav(){
      this.isActive = !this.isActive;
      //document.getElementById("custom-collapse").style.display = "block";
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.name == "FAQ") {
        this.mediaLink = "/#media";
       // location.href = "/#media";
        
      }
    }
  },
  mounted() {
    this.noMove();
    this.scroll();
    
  }
};
</script>

<style>
.navbar-collapse.active {
    display: block;
} 

.overlay-content .col-xs-12 {
    padding-top: 250px;
}
li.suscribeList a {
    padding: 0;
}

@font-face {
  font-family: Digitalt;
  src: url(/static/assets/lib/Digitalt.otf);
}

/* DEBUG: Disable until links can actual go to other sites */
/* #navbar {
  display: none;
} */
nav.navbar {
  top: -100px;
  transition: all ease-in .3s !important;
}
.scroll-up a {
    background: #196090;
    display: block;
    height: 37px;
    width: 37px;
    text-align: center;
    line-height: 28px;
    font-size: 32px;
    padding: 4px;
    color: #000;
    opacity: 0.6;
    border-radius: 2px;
}

.scroll-up i {
  color: #33adff;
}

.dwerve-logo {
  margin-top: -4px;
}
div#custom-collapse {
  margin-top: 4px;
}
.navbar1 {
  display: block;
}
a.suscribeBtn:hover {
  background-color: #3498dc !important;
}
.suscribeBtn::before,
.suscribeBtn::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.suscribeBtn {
  display: inline-block;
  padding: 20px 40px;
  color: white;
  position: absolute;
  top: 50%;
  left: 69%;
  margin-top: 31px;
  transform: translate(-50%, -50%);
  vertical-align: middle;
  font-family: Digitalt, sans-serif;
  text-decoration: none;
  font-size: 2vw;
  transition: all 0.5s;
  background-color: #3498db;
}
.suscribeBtn::before {
  bottom: -5px;
  height: 5px;
  width: 100%;
  left: 2px;
  transform: skewX(45deg);
  background-color: #196090;
}
.suscribeBtn::after {
  right: -5px;
  height: 100%;
  width: 5px;
  bottom: -3px;
  transform: skewY(45deg);
  background-color: #124364;
}
.suscribeBtn:active {
  margin-left: 3px;
  margin-top: 31px;
}
.suscribeBtn:active::before {
  bottom: -5px;
  height: 5px;
  left: 3px;
}
.suscribeBtn:active::after {
  right: -5px;
  width: 5px;
  bottom: -3px;
}
ul.nav.navbar-nav.navbar-left {
  font-family: Grandmaster;
}
li.suscribeList img {
    width: 127px;
    position: relative;
    top: 7px;
    cursor: pointer;
}
@font-face {
  font-family: Grandmaster;
  src: url(/static/assets/lib/Grandstander-clean.otf);
}
@media (max-width: 468px) {
  ul.nav.navbar-nav.navbar-left {
    padding-top: 19px;
  }
 
}
@media (min-width: 781px) {
  .navbar-right {
    float: right !important;
    margin-right: 14px !important;
  }
}
@media (width: 768px) {
  .navbar-right {
    float: right !important;
    margin-right: 4px !important;
  }
}
@media (max-width: 890px) {
  .navbar-custom {
    font-size: 17px;
  }
}

.icon-bar-social {
  -webkit-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
  position: fixed;
  top: 69px;
  margin-left: 0;
  /* right: 20px; */
  width: 56px;
  float: left;
  z-index: 2;
  /* left: 100%; */
}
.icon-bar-social a:hover {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-2px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(2px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-2px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(2px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
/* Style the icon bar links */
.icon-bar-social a {
  display: block;
  text-align: center;
  padding-bottom: 0 !important;
  margin-bottom: 0;
  padding: 10px;
  transition: all 0.3s ease;
  color: white;
  font-size: 20px;
}

.icon-bar-social a img {
    width: 36px;
    height: 36px;
}

@media only screen and (max-width: 854px) {
  .navbar-custom .nav li > a{
   font-size: 18px;
  }
}
@media only screen and (width: 1024px) {
  .icon-bar-social {
    top: 23%;
  }
}
@media (max-width: 767px) {
  .nav > li {
    text-align: center;
  }
  .suscribeBtn {
    left: 50%;
    float: left;
  }
  /* .suscribeList {
    padding-right: 0px !important;
  } */
  ul.nav.navbar-nav.navbar-left {
    margin-top: 35px;
  }
}
.facebook {
  background: #3b5998;
  color: white;
}

.twitter {
  background: #55acee;
  color: white;
}

.google {
  background: #dd4b39;
  color: white;
}

.linkedin {
  background: #007bb5;
  color: white;
}

.youtube {
  background: #bb0000;
  color: white;
}
@media only screen and (max-width: 450px) {
  .suscribeBtn {
    left: 53%;
    font-size: 4vw;
  }
  .nav > li > a {
    padding: 9px 23px;
  }
}



h3.cta-title {
  display: block;
}


@media only screen and (min-width: 700px) and (max-width: 1070px) {
  li.suscribeList {
    display: none;
}
}
.navbar-custom .nav li > a:hover {
    color: #267fbc;
    text-shadow: 0 3px 0px rgb(255, 255, 255), 0px 8px 13px rgba(52, 149, 216, 0.16), 0px 18px 23px rgba(204, 54, 54, 0);
}
@keyframes bounce {
	0%, 100%, 20%, 50%, 80% {
		-webkit-transform: translateY(0);
		-ms-transform:     translateY(0);
		transform:         translateY(0)
	}
	40% {
		-webkit-transform: translateY(-30px);
		-ms-transform:     translateY(-30px);
		transform:         translateY(-30px)
	}
	60% {
		-webkit-transform: translateY(-15px);
		-ms-transform:     translateY(-15px);
		transform:         translateY(-15px)
	}
}
.bounce_button:hover {
  -webkit-animation: shake 0.5s;
    animation: shake 0.5s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}
.scroll-up {
    position: fixed;
    display: none;
    bottom: 7px;
    right: 6px;
    z-index: 999;
}

</style>



// WEBPACK FOOTER //
// src/views/Home/Navbar.vue